import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PesapalPayment from "./components/PesapalPayment";
import PaymentSuccess from "./components/PaymentSuccess";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/:invoiceId" element={<PesapalPayment />} />
          <Route path="/success/:invoiceId" element={<PaymentSuccess />} />
          <Route path="/" element={<Navigate to="/invalid" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
